import { Box, BoxProps, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { AddBankCode } from './AddBankCode'
import { Details } from './Details'

const EditBankingCode = (props: any) => {
  const { route } = props
  const { id } = route?.params ?? ''
  localStorage.setItem('params', id)
  const [isEditVisible, setIsEditVisible] = useState(false)
  const [toggleDelete, setDelete] = useState(false)
  const { accessConfig, getBankingCodeById, deleteBankCode, getBankingCode } = useStores((store) => ({
    getBankingCodeById: store.bankingCode.getBankingCodeById,
    deleteBankCode: store.bankingCode.deleteBankCode,
    getBankingCode: store.bankingCode.getBankingCode,
    accessConfig: store.user.getAccessConfig(['sys_control_config', 'banking_codes']),
  }))
  const [lazyDeleteCode, { state }] = useLazyApiData(deleteBankCode)
  const [lazyGetBankingCode] = useLazyApiData(getBankingCode)

  useEffect(() => {
    lazyGetBankingCode(id)
  }, [lazyGetBankingCode, id])

  const navigation = useNavigation()
  useEffect(() => {
    if (state === 'fulfilled') {
      navigation?.navigate('bankingcodes')
    }
  }, [navigation, state])
  const getDetails = () => {
    const data = getBankingCodeById(id)
    return {
      details: {
        code: data.code,
        name: data.name,
        type: data.type,
        status: data?.status ? data.status?.toUpperCase() + 'D' : '',
      },
      description: data.description,
      extras: {
        extraField1: data.extraField1,
        extraField2: data.extraField2,
      },
    }
  }

  const handleDelete = () => {
    lazyDeleteCode(id)
    setDelete(false)
  }
  return (
    <Box>
      <Text title={'Banking Code Detail'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Box
        flexDirection="row"
        alignItems="center"
        justify="flex-end"
        {...styles.header}
        bg={'#f8f9fc' as ColorOptions}
        paddingHorizontal={24}
        paddingVertical={16}>
        <Box flexDirection="row">
          {isAccessible(accessConfig, 'update') && (
            <Box
              flexDirection="row"
              backgroundColor="ORANGE"
              padding={8}
              borderRadius={4}
              onPress={() => setIsEditVisible(true)}
              underlayColor="YELLOW">
              <Icon id="EDIT" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Edit</Text>
            </Box>
          )}
          <Spacer direction="horizontal" size={16} />
          {isAccessible(accessConfig, 'delete') && (
            <Box
              flexDirection="row"
              backgroundColor="RED"
              padding={8}
              borderRadius={4}
              onPress={() => setDelete(true)}
              underlayColor="ERROR">
              <Icon id="DELETE" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Delete</Text>
            </Box>
          )}
        </Box>
      </Box>
      <ModalAlertView
        show={toggleDelete}
        onDismiss={() => setDelete(false)}
        title="Delete Banking Code"
        message={`Is this final. This will delete banking code with ID ${id}`}
        onPress={handleDelete}
        onCancel={() => setDelete(false)}
        buttonTitle="Delete"
        isLoading={false}
      />
      <Details data={getDetails()} hide={isEditVisible} />
      {isEditVisible && (
        <AddBankCode
          id={id}
          initialData={getBankingCodeById(id)}
          onUpdate={() => navigation?.navigate('bankingcodes')}
        />
      )}
    </Box>
  )
}

export default EditBankingCode
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
